<template>
  <div class="home">
    <v-layout row>
      <v-flex xs12>
        <!--<v-card>
      <p class="red">Sorry, the page you're looking for doesn't exist.</p>
      </v-card>-->
      <v-jumbotron>
         <p class="display-4 text-xs-center font-weight-medium pt-5">404</p>
            <div class="display-1  text-xs-center">{{msg}}</div>
      </v-jumbotron>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
	// import { Store } from 'vuex'

export default {
  name: 'ErrorPage',
  data () {
    return {
      msg: 'Whoops !, The page you\'re looking for doesn\'t exist. Search the page correctly'
    }
  },
  created () {
    this.$store.state.sideNav = false
  }
}
</script>

<style>
/* .navigation{
  display:none !important
} */
</style>



// WEBPACK FOOTER //
// src/components/404.vue